module.exports = __webpack_public_path__ + "img/成都大学.568ba11e.png";